import styled from 'styled-components'

export const ImageThumbnail = styled.img`
    display: block;
    max-width: 80%;
    margin: 0 auto 15px;
`
